export default __webpack_public_path__ + "static/media/socialInstagramdark.abea798c.svg";